import { Box, Heading, Icon, Tooltip } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import _ from "lodash";
import FilterForm from "../../../components/FilterForm";
import { Info } from "lucide-react";
import ArrivalRatesPerHourReport from "../../../components/organization/reports/realtime/OrganizationArrivalRatesPerHour";
import { Helmet } from "react-helmet";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";

const OrganizationArrivalRatesPerHour = ({
  showFilterForm = false,
  reportIndex = 1,
}) => {
  const { reportRange, workDay } = useSelector((state) => state.defaultReducer);
  const reportTitle = `Arrival Rates Per Hour`;
  
  return (
    <Box>
      <Helmet>
        <title>{reportTitle}</title>
      </Helmet>
      {showFilterForm ? <FilterForm /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange).OrganizationArrivalRatesPerHour}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <ArrivalRatesPerHourReport reportIndex={reportIndex} />
        )}
      </>
    </Box>
  );
};

export default OrganizationArrivalRatesPerHour;
